import React, { useCallback, useState } from "react";

import Abertura from "./Abertura";
import { variaveisDaRegiao } from "./estiloDaRegiao";
import IntroMascote from "./IntroMascote";
import SelecaoAvatar from "./SelecaoAvatar";

/**
 * Primeira entrada na trilha: abertura com o mapa → escolha do explorador →
 * apresentação do mascote.
 *
 * Ocupa a LARGURA CHEIA DO CONTAINER PAI, no fluxo da página — o mesmo espaço e a
 * mesma largura máxima que o tabuleiro ocupa, para a passagem onboarding → trilha
 * não dar salto de layout. No celular isso vale a largura toda da tela, porque a
 * ponte do AVA fura o respiro lateral da página (ver
 * `components/ItensDaAtividade/sangriaMobile.css`).
 *
 * Isto já foi em tela cheia por portal (como a cerimônia de card) e voltou para
 * o fluxo, porque a tela cheia é um MODO — ligado por um ícone e valendo para a
 * atividade inteira, abertura, seleção e tabuleiro juntos — e não o padrão de uma
 * etapa só. Quem envolve é `ModoTelaCheia`; o CSS está em `styles/telaCheia.css`,
 * e é ele que amplia o palco de 520 para 820px, largura em que os 4 exploradores
 * cabem numa linha só.
 *
 * @param {object}   regiao      { id, nome, mascote }
 * @param {Array}    avatares
 * @param {string}   avatarId    escolha anterior, se houver
 * @param {boolean}  pularMapa   quando o aluno já viu a abertura
 * @param {Function} onConcluir  recebe o id do avatar escolhido
 */
function Onboarding({
  regiao,
  avatares,
  avatarId = null,
  pularMapa = false,
  onConcluir
}) {
  const [etapa, setEtapa] = useState(pularMapa ? "avatar" : "abertura");
  const [escolhido, setEscolhido] = useState(avatarId);

  const irParaAvatar = useCallback(() => setEtapa("avatar"), []);

  function escolherAvatar(id) {
    setEscolhido(id);
    setEtapa("mascote");
  }

  return (
    // `data-tl-etapa` é contrato com o CSS, como `data-tl-region` no mapa: quem
    // decide o fundo de cada etapa é a folha de estilo. Mar na abertura (o mapa é
    // o Brasil visto de fora), a ilustração DA REGIÃO a partir do momento em que o
    // aluno "chega" nela.
    //
    // AS CUSTOM PROPERTIES VÃO AQUI, e herdar da moldura da tela cheia NÃO basta:
    // este div tem a classe `trilha-ludica`, e o CSS declara os tokens da região
    // nela. Declaração no próprio elemento vence valor herdado do pai, então sem
    // este `style` o palco lia sempre o padrão do CSS — o da Caatinga. Foi visto no
    // app em 05/08/2026: trilha do Norte, e a escolha do explorador com fundo de
    // deserto e cactos.
    <div
      className="trilha-ludica trilha-ludica__palco"
      data-tl-etapa={etapa}
      style={variaveisDaRegiao(regiao)}
    >
      {etapa === "abertura" && (
        <Abertura regiao={regiao} onConcluir={irParaAvatar} />
      )}

      {etapa === "avatar" && (
        <SelecaoAvatar
          avatares={avatares}
          avatarId={escolhido}
          onConcluir={escolherAvatar}
        />
      )}

      {etapa === "mascote" && (
        <IntroMascote
          mascote={regiao.mascote}
          onFechar={() => onConcluir(escolhido)}
        />
      )}
    </div>
  );
}

export default Onboarding;
